import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PatiProject } from '../models/pati-project.model';
import { GraphUser } from '../models/graph-user.model';
import { ReleaseDetail } from '../models/release-detail.model';
import { Allocation } from '../models/allocation.model';
import { Building } from '../models/building.model';
import { LaborDetail } from '../models/labor-detail.model';
import { ContingencyDetail } from '../models/contingency-detail.model';
import { UploadFile } from '../models/upload-file.model';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DataService } from '../services/data.service';
import { ItProject } from '../models/it-project.model';
import _ from 'lodash';
import { ConfigService } from '../services/config.service';
import { CapabilityDescriptionComponent } from '../capability-description/capability-description.component';

@Component({
  selector: 'app-it-project-review',
  templateUrl: './it-project-review.component.html',
  styleUrls: ['./it-project-review.component.scss'],
  standalone: false,
})
export class ItProjectReviewComponent implements OnInit {
  patiProject: PatiProject;
  displayPatiProject: string;
  projectName: string;
  itProjectClassification: any;
  estimatedStartDate: Date;
  estimatedInServiceDate: Date;
  projectScopeDescription: string;
  primaryContact: GraphUser;
  displayPrimaryContact: string;
  itSponsor: GraphUser;
  displayItSponsor: string;
  omOnly: string;
  relatedWork: string;
  hardwareOrSoftware: any;
  purchasingWarranties: string;
  projectConsistsOf: string[];
  projectConsistsOfOptions: string[];
  projectConsistsOfCheckboxes: boolean[];
  expectedLife: number;
  agileEffort: string;
  softwareBeingUsed: string;
  vendorName: string;
  softwareName: string;
  inServiceYear: string;
  softwareProjectOverview: string;
  dataConversionActivities: string;
  trainingCosts: string;
  associatedRetirement: string;
  softwareToBeRetired: string;
  retiredInServiceDate: string;
  maintenanceContracts: string;
  replacingInterfaces: string;
  howSoftwareReleased: string;
  perpetualLicenses: string;
  contractualRight: string;
  significantPenalty: string;
  isFeasible: string;
  serviceFees: string;
  useWithoutPaying: string;
  department: any;
  buildingInfo: any;
  releaseDetails: ReleaseDetail[];
  distributeCost: any;
  defaultOption: any;
  allocations: Allocation[];
  buildings: Building[];
  extraBuildings: string[];
  laborDetails: LaborDetail[];
  contingencyDetails: ContingencyDetail[];
  additionalComments: string;
  files: UploadFile[];
  doaAmounts: number[];
  approverList: any[];
  nuclearAbbreviations: any[];
  itProjects: ItProject[];
  itSparGuid: string;
  projectClassDerivations: any[];
  projectTypeDerivations: any[];
  uopOptions: string[];
  ouAssetLocMajorLoc: any[];
  itPopAssetLocMajorLoc: any[];
  buTypeDerivation: any[];
  utilityRetirementDerivation: any[];
  activityDerivation: any[];
  accountingModelDerivation: any[];
  additionalApprovers: GraphUser[];
  draftSaved: string;
  draftSavedDate: Date;
  draftSavedDay: string;
  draftSavedTime: string;
  userName: string;
  userEmail: string;
  firstName: string;
  lastName: string;
  formNumber: string;
  displayRevisionNumber: number;
  pacEmail: any;
  emailRecipients: any;
  previousCapitalSubtotal: number;
  previousOMSubtotal: number;
  pacUsers: GraphUser[];
  pacOrder: GraphUser[];
  etsPacAssignment: any;
  private httpNoInterceptors: HttpClient;

  constructor(
    private router: Router,
    private http: HttpClient,
    private dialog: MatDialog,
    private dataService: DataService,
    private config: ConfigService,
    private httpBackend: HttpBackend
  ) {
    this.httpNoInterceptors = new HttpClient(httpBackend);
  }

  ngOnInit() {
    let userData = JSON.parse(sessionStorage.getItem('userInfo'));
    if (userData) {
      let stringArray = userData.account.name.split(',');
      this.lastName = stringArray[0];
      this.firstName = stringArray[1].substring(1);
      this.userName = this.firstName + ' ' + this.lastName;
      this.userEmail = userData.account.username;
    }
    this.loadProjectData();
    this.loadUOPOptionsFile();
    this.loadEmailRecipientsFile();
    this.loadNuclearAbbreviations();
    this.getPACUsers();
    this.getPACOrder();
  }

  goToSetupPage() {
    sessionStorage.removeItem('itSparGuid');
    this.router.navigate(['/it-project-setup']);
  }

  goToEstimatePage() {
    this.router.navigate(['/it-project-estimate']);
  }

  loadProjectData() {
    let patiProjectCheck = sessionStorage.getItem('patiProject');
    if (patiProjectCheck) {
      this.patiProject = JSON.parse(patiProjectCheck);
      this.displayPatiProject = this.patiProject.Project_ID.concat(' - ').concat(
        this.patiProject.Project_Name
      );
    } else {
      this.patiProject = null;
    }
    let projectNameCheck = sessionStorage.getItem('projectName');
    if (projectNameCheck) {
      this.projectName = projectNameCheck;
    } else {
      this.projectName = '';
    }
    let itProjectClassificationCheck = sessionStorage.getItem('itProjectClassification');
    if (itProjectClassificationCheck) {
      this.itProjectClassification = JSON.parse(itProjectClassificationCheck);
    } else {
      this.itProjectClassification = null;
    }
    let startDateCheck = sessionStorage.getItem('estimatedStartDate');
    if (startDateCheck) {
      this.estimatedStartDate = new Date(startDateCheck);
      this.estimatedStartDate.setDate(this.estimatedStartDate.getDate() + 1);
    } else {
      this.estimatedStartDate = null;
    }
    let inServiceDateCheck = sessionStorage.getItem('estimatedInServiceDate');
    if (inServiceDateCheck) {
      this.estimatedInServiceDate = new Date(inServiceDateCheck);
      this.estimatedInServiceDate.setDate(this.estimatedInServiceDate.getDate() + 1);
    } else {
      this.estimatedInServiceDate = null;
    }
    let projectScopeDescriptionCheck = sessionStorage.getItem('projectScopeDescription');
    if (projectScopeDescriptionCheck) {
      this.projectScopeDescription = projectScopeDescriptionCheck;
    } else {
      this.projectScopeDescription = '';
    }
    let primaryContactCheck = sessionStorage.getItem('primaryContact');
    if (primaryContactCheck) {
      this.primaryContact = JSON.parse(primaryContactCheck);
      if (
        this.primaryContact.givenName &&
        this.primaryContact.surname &&
        this.primaryContact.jobTitle
      ) {
        this.displayPrimaryContact = this.primaryContact.givenName
          .concat(' ')
          .concat(this.primaryContact.surname)
          .concat(' (')
          .concat(this.primaryContact.mail)
          .concat('), ')
          .concat(this.primaryContact.jobTitle);
      }
      if (
        this.primaryContact.givenName &&
        this.primaryContact.surname &&
        !this.primaryContact.jobTitle
      ) {
        this.displayPrimaryContact = this.primaryContact.givenName
          .concat(' ')
          .concat(this.primaryContact.surname)
          .concat(' (')
          .concat(this.primaryContact.mail)
          .concat(')');
      }
      if (
        !(this.primaryContact.givenName && this.primaryContact.surname) &&
        this.primaryContact.jobTitle
      ) {
        this.displayPrimaryContact = this.primaryContact.displayName
          .concat(' (')
          .concat(this.primaryContact.mail)
          .concat('), ')
          .concat(this.primaryContact.jobTitle);
      }
      if (
        !(this.primaryContact.givenName && this.primaryContact.surname) &&
        !this.primaryContact.jobTitle
      ) {
        this.displayPrimaryContact = this.primaryContact.displayName
          .concat(' (')
          .concat(this.primaryContact.mail)
          .concat(')');
      }
    } else {
      this.primaryContact = null;
    }
    let itSponsorCheck = sessionStorage.getItem('itSponsor');
    if (itSponsorCheck) {
      this.itSponsor = JSON.parse(itSponsorCheck);
      if (this.itSponsor.givenName && this.itSponsor.surname && this.itSponsor.jobTitle) {
        this.displayItSponsor = this.itSponsor.givenName
          .concat(' ')
          .concat(this.itSponsor.surname)
          .concat(' (')
          .concat(this.itSponsor.mail)
          .concat('), ')
          .concat(this.itSponsor.jobTitle);
      }
      if (this.itSponsor.givenName && this.itSponsor.surname && !this.itSponsor.jobTitle) {
        this.displayItSponsor = this.itSponsor.givenName
          .concat(' ')
          .concat(this.itSponsor.surname)
          .concat(' (')
          .concat(this.itSponsor.mail)
          .concat(')');
      }
      if (!(this.itSponsor.givenName && this.itSponsor.surname) && this.itSponsor.jobTitle) {
        this.displayItSponsor = this.itSponsor.displayName
          .concat(' (')
          .concat(this.itSponsor.mail)
          .concat('), ')
          .concat(this.itSponsor.jobTitle);
      }
      if (!(this.itSponsor.givenName && this.itSponsor.surname) && !this.itSponsor.jobTitle) {
        this.displayItSponsor = this.itSponsor.displayName
          .concat(' (')
          .concat(this.itSponsor.mail)
          .concat(')');
      }
    } else {
      this.itSponsor = null;
    }
    let omOnlyCheck = sessionStorage.getItem('omOnly');
    this.omOnly = omOnlyCheck ? omOnlyCheck : '';

    let relatedWorkCheck = sessionStorage.getItem('relatedWork');
    this.relatedWork = relatedWorkCheck ? relatedWorkCheck : '';

    let hardwareOrSoftwareCheck = sessionStorage.getItem('hardwareOrSoftware');
    if (hardwareOrSoftwareCheck) {
      this.hardwareOrSoftware = hardwareOrSoftwareCheck;
    } else {
      this.hardwareOrSoftware = null;
    }
    let purchasingWarrantiesCheck = sessionStorage.getItem('purchasingWarranties');
    if (purchasingWarrantiesCheck) {
      this.purchasingWarranties = purchasingWarrantiesCheck;
    } else {
      this.purchasingWarranties = '';
    }
    let projectConsistsOfCheck = sessionStorage.getItem('projectConsistsOf');
    if (projectConsistsOfCheck) {
      this.projectConsistsOf = JSON.parse(projectConsistsOfCheck);
    } else {
      this.projectConsistsOf = [];
    }
    let projectConsistsOfCheckboxesCheck = sessionStorage.getItem('projectConsistsOfCheckboxes');
    if (projectConsistsOfCheckboxesCheck) {
      this.projectConsistsOfCheckboxes = JSON.parse(projectConsistsOfCheckboxesCheck);
    } else {
      this.projectConsistsOfCheckboxes = [];
    }
    let projectConsistsOfOptionsCheck = sessionStorage.getItem('projectConsistsOfOptions');
    if (projectConsistsOfOptionsCheck) {
      this.projectConsistsOfOptions = JSON.parse(projectConsistsOfOptionsCheck);
    } else {
      this.projectConsistsOfOptions = [];
    }
    let expectedLifeCheck = sessionStorage.getItem('expectedLife');
    if (expectedLifeCheck) {
      this.expectedLife = Number(expectedLifeCheck);
    } else {
      this.expectedLife = null;
    }
    let agileEffortCheck = sessionStorage.getItem('agileEffort');
    if (agileEffortCheck) {
      this.agileEffort = agileEffortCheck;
    } else {
      this.agileEffort = '';
    }
    let softwareBeingUsedCheck = sessionStorage.getItem('softwareBeingUsed');
    if (softwareBeingUsedCheck) {
      this.softwareBeingUsed = softwareBeingUsedCheck;
    } else {
      this.softwareBeingUsed = '';
    }
    let vendorNameCheck = sessionStorage.getItem('vendorName');
    if (vendorNameCheck) {
      this.vendorName = vendorNameCheck;
    } else {
      this.vendorName = '';
    }
    let softwareNameCheck = sessionStorage.getItem('softwareName');
    if (softwareNameCheck) {
      this.softwareName = softwareNameCheck;
    } else {
      this.softwareName = '';
    }
    let inServiceYearCheck = sessionStorage.getItem('inServiceYear');
    if (inServiceYearCheck) {
      this.inServiceYear = inServiceYearCheck;
    } else {
      this.inServiceYear = '';
    }
    let softwareProjectOverviewCheck = sessionStorage.getItem('softwareProjectOverview');
    if (softwareProjectOverviewCheck) {
      this.softwareProjectOverview = softwareProjectOverviewCheck;
    } else {
      this.softwareProjectOverview = '';
    }
    let dataConversionActivitiesCheck = sessionStorage.getItem('dataConversionActivities');
    if (dataConversionActivitiesCheck) {
      this.dataConversionActivities = dataConversionActivitiesCheck;
    } else {
      this.dataConversionActivities = '';
    }
    let trainingCostsCheck = sessionStorage.getItem('trainingCosts');
    if (trainingCostsCheck) {
      this.trainingCosts = trainingCostsCheck;
    } else {
      this.trainingCosts = '';
    }
    let associatedRetirementCheck = sessionStorage.getItem('associatedRetirement');
    if (associatedRetirementCheck) {
      this.associatedRetirement = associatedRetirementCheck;
    } else {
      this.associatedRetirement = '';
    }
    let softwareToBeRetiredCheck = sessionStorage.getItem('softwareToBeRetired');
    if (softwareToBeRetiredCheck) {
      this.softwareToBeRetired = softwareToBeRetiredCheck;
    } else {
      this.softwareToBeRetired = '';
    }
    let retiredInServiceDateCheck = sessionStorage.getItem('retiredInServiceDate');
    if (retiredInServiceDateCheck) {
      this.retiredInServiceDate = retiredInServiceDateCheck;
    } else {
      this.retiredInServiceDate = '';
    }
    let maintenanceContractsCheck = sessionStorage.getItem('maintenanceContracts');
    if (maintenanceContractsCheck) {
      this.maintenanceContracts = maintenanceContractsCheck;
    } else {
      this.maintenanceContracts = '';
    }
    let replacingInterfacesCheck = sessionStorage.getItem('replacingInterfaces');
    if (replacingInterfacesCheck) {
      this.replacingInterfaces = replacingInterfacesCheck;
    } else {
      this.replacingInterfaces = '';
    }
    let howSoftwareReleasedCheck = sessionStorage.getItem('howSoftwareReleased');
    if (howSoftwareReleasedCheck) {
      this.howSoftwareReleased = howSoftwareReleasedCheck;
    } else {
      this.howSoftwareReleased = '';
    }
    let perpetualLicensesCheck = sessionStorage.getItem('perpetualLicenses');
    if (perpetualLicensesCheck) {
      this.perpetualLicenses = perpetualLicensesCheck;
    } else {
      this.perpetualLicenses = '';
    }
    let contractualRightCheck = sessionStorage.getItem('contractualRight');
    if (contractualRightCheck) {
      this.contractualRight = contractualRightCheck;
    } else {
      this.contractualRight = '';
    }
    let significantPenaltyCheck = sessionStorage.getItem('significantPenalty');
    if (significantPenaltyCheck) {
      this.significantPenalty = significantPenaltyCheck;
    } else {
      this.significantPenalty = '';
    }
    let isFeasibleCheck = sessionStorage.getItem('isFeasible');
    if (isFeasibleCheck) {
      this.isFeasible = isFeasibleCheck;
    } else {
      this.isFeasible = '';
    }
    let serviceFeesCheck = sessionStorage.getItem('serviceFees');
    if (serviceFeesCheck) {
      this.serviceFees = serviceFeesCheck;
    } else {
      this.serviceFees = '';
    }
    let useWithoutPayingCheck = sessionStorage.getItem('useWithoutPaying');
    if (useWithoutPayingCheck) {
      this.useWithoutPaying = useWithoutPayingCheck;
    } else {
      this.useWithoutPaying = '';
    }
    let departmentCheck = sessionStorage.getItem('department');
    if (departmentCheck) {
      this.department = JSON.parse(departmentCheck);
    } else {
      this.department = null;
    }
    let buildingInfoCheck = sessionStorage.getItem('buildingInfo');
    if (buildingInfoCheck) {
      this.buildingInfo = JSON.parse(buildingInfoCheck);
    } else {
      this.buildingInfo = null;
    }
    let releaseDetailsCheck = sessionStorage.getItem('releaseDetails');
    if (releaseDetailsCheck) {
      this.releaseDetails = JSON.parse(releaseDetailsCheck);
    } else {
      this.releaseDetails = [new ReleaseDetail()];
    }
    let distributeCostCheck = sessionStorage.getItem('distributeCost');
    if (distributeCostCheck) {
      this.distributeCost = JSON.parse(distributeCostCheck);
    } else {
      this.distributeCost = null;
    }
    let defaultOptionCheck = sessionStorage.getItem('defaultOption');
    if (defaultOptionCheck) {
      this.defaultOption = JSON.parse(defaultOptionCheck);
    } else {
      this.defaultOption = null;
    }
    let allocationsCheck = sessionStorage.getItem('allocations');
    if (allocationsCheck) {
      this.allocations = JSON.parse(allocationsCheck);
      for (let i = 0; i < this.allocations.length; i++) {
        if (this.allocations[i].operatingUnit) {
          this.allocations[i].displayOperatingUnit = this.allocations[
            i
          ].operatingUnit.OPERATING_UNIT.concat(' - ').concat(
            this.allocations[i].operatingUnit.DESCR
          );
        }
      }
    } else {
      this.allocations = null;
    }
    let buildingsCheck = sessionStorage.getItem('buildings');
    if (buildingsCheck) {
      this.buildings = JSON.parse(buildingsCheck);
    } else {
      this.buildings = null;
    }
    let laborDetailsCheck = sessionStorage.getItem('laborDetails');
    if (laborDetailsCheck) {
      this.laborDetails = JSON.parse(laborDetailsCheck);
      for (let i = 0; i < this.laborDetails.length; i++) {
        if (!this.laborDetails[i].workTask) {
          this.laborDetails[i] = {
            workTask: {
              workTask: '',
            },
            workDescription: '',
            chargeType: '',
            totalCosts: '',
          };
        }
      }
    } else {
      this.laborDetails = [];
    }
    let contingencyDetailsCheck = sessionStorage.getItem('contingencyDetails');
    if (contingencyDetailsCheck) {
      this.contingencyDetails = JSON.parse(contingencyDetailsCheck);
    } else {
      this.contingencyDetails = [];
    }
    let additionalCommentsCheck = sessionStorage.getItem('additionalComments');
    if (additionalCommentsCheck) {
      this.additionalComments = JSON.parse(additionalCommentsCheck);
    } else {
      this.additionalComments = null;
    }
    let filesCheck = sessionStorage.getItem('files');
    if (filesCheck) {
      this.files = JSON.parse(filesCheck);
    } else {
      this.files = [];
    }
    let doaAmountsCheck = sessionStorage.getItem('doaAmounts');
    if (doaAmountsCheck) {
      this.doaAmounts = JSON.parse(doaAmountsCheck);
    } else {
      this.doaAmounts = [0];
    }
    let approverListCheck = sessionStorage.getItem('approverList');
    if (approverListCheck) {
      this.approverList = JSON.parse(approverListCheck);
    } else {
      this.approverList = [];
    }
    let extraBuildingsCheck = sessionStorage.getItem('extraBuildings');
    if (extraBuildingsCheck) {
      this.extraBuildings = JSON.parse(extraBuildingsCheck);
    } else {
      this.extraBuildings = [];
    }
    let additionalApproversCheck = sessionStorage.getItem('additionalApprovers');
    if (additionalApproversCheck) {
      this.additionalApprovers = JSON.parse(additionalApproversCheck);
    } else {
      this.additionalApprovers = [];
    }
    let draftSavedCheck = sessionStorage.getItem('draftSaved');
    if (draftSavedCheck) {
      this.draftSaved = draftSavedCheck;
    } else {
      this.draftSaved = '';
    }
    let draftSavedDayCheck = sessionStorage.getItem('draftSavedDay');
    if (draftSavedDayCheck) {
      this.draftSavedDay = draftSavedDayCheck;
    } else {
      this.draftSavedDay = '';
    }
    let draftSavedTimeCheck = sessionStorage.getItem('draftSavedTime');
    if (draftSavedTimeCheck) {
      this.draftSavedTime = draftSavedTimeCheck;
    } else {
      this.draftSavedTime = '';
    }
    let itSparGuidCheck = sessionStorage.getItem('itSparGuid');
    if (itSparGuidCheck) {
      this.itSparGuid = JSON.parse(itSparGuidCheck);
    } else {
      this.itSparGuid = '';
    }
    let formNumberCheck = sessionStorage.getItem('formNumber');
    if (formNumberCheck) {
      this.formNumber = formNumberCheck;
    } else {
      this.formNumber = '';
    }
    let displayRevisionNumberCheck = sessionStorage.getItem('displayRevisionNumber');
    if (displayRevisionNumberCheck) {
      this.displayRevisionNumber = Number(displayRevisionNumberCheck);
    } else {
      this.displayRevisionNumber = 0;
    }
    let previousCapitalSubtotalCheck = sessionStorage.getItem('previousCapitalSubtotal');
    if (previousCapitalSubtotalCheck) {
      this.previousCapitalSubtotal = Number(previousCapitalSubtotalCheck);
    } else {
      this.previousCapitalSubtotal = 0;
    }
    let previousOMSubtotalCheck = sessionStorage.getItem('previousOMSubtotal');
    if (previousOMSubtotalCheck) {
      this.previousOMSubtotal = Number(previousOMSubtotalCheck);
    } else {
      this.previousOMSubtotal = 0;
    }
    let etsPacAssignmentCheck = sessionStorage.getItem('etsPacAssignment');
    if (etsPacAssignmentCheck) {
      this.etsPacAssignment = JSON.parse(etsPacAssignmentCheck);
    } else {
      this.etsPacAssignment = null;
    }
  }

  loadNuclearAbbreviations() {
    this.http.get('assets/nuclear-abbreviations.json').subscribe(
      (result) => {
        this.nuclearAbbreviations = result as any[];
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Nuclear Abbreviations Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Nuclear Abbreviations Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  downloadFile(index: number) {
    let data = {
      fileName: this.itSparGuid.concat('/').concat(this.files[index].fileName),
      contentType: this.files[index].contentType,
      method: 'get_object',
    };
    this.dataService.getPresignedURL(data).subscribe(
      (result) => {
        let presignedUrl = JSON.parse(result as string).presigned_url;
        this.http
          .get(presignedUrl, {
            responseType: 'blob',
          })
          .subscribe((result) => {
            let fileURL = URL.createObjectURL(result);
            let downloadLink = document.createElement('a');
            downloadLink.href = fileURL;
            downloadLink.download = this.files[index].fileName;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          });
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Presigned URL Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Presigned URL Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  contingencyTotal() {
    let contingencyTotal = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      contingencyTotal += Number(this.contingencyDetails[i].totalCosts || 0);
    }
    return Math.round(contingencyTotal);
  }

  laborTotal() {
    let laborTotal = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      laborTotal += Number(this.laborDetails[i].totalCosts || 0);
    }
    return Math.round(laborTotal);
  }

  buildingTotal() {
    let buildingTotal = 0;
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        buildingTotal += Number(this.buildings[i].materialEstimates[j].totalCosts);
      }
    }
    return Math.round(buildingTotal);
  }

  isVendorHosted() {
    return this.projectConsistsOf.includes(
      'Purchase - Vendor Hosted/Leased, Cloud Computing, or SaaS'
    );
  }

  stateDisabled(allocation: Allocation) {
    if (!this.buildingInfo || this.buildingInfo.BuildingName !== 'IT POP') {
      return true;
    } else {
      return allocation.stateOptions.length === 0;
    }
  }

  allocationTotal() {
    let total = 0;
    for (let i = 0; i < this.allocations.length; i++) {
      total += this.allocations[i].percentage;
    }
    return Number(total.toPrecision(6));
  }

  internalOM() {
    let internalOM = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask.workTask === 'Labor-O&M' ||
        this.laborDetails[i].workTask.workTask === 'Hardware-O&M' ||
        this.laborDetails[i].workTask.workTask === 'Software-O&M'
      ) {
        if (this.laborDetails[i].chargeType === 'Internal') {
          internalOM += Number(this.laborDetails[i].totalCosts || 0);
        }
      }
    }
    return Math.round(internalOM);
  }

  externalOM() {
    let externalOM = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask.workTask === 'Labor-O&M' ||
        this.laborDetails[i].workTask.workTask === 'Hardware-O&M' ||
        this.laborDetails[i].workTask.workTask === 'Software-O&M'
      ) {
        if (this.laborDetails[i].chargeType === 'External') {
          externalOM += Number(this.laborDetails[i].totalCosts || 0);
        }
      }
    }
    return Math.round(externalOM);
  }

  materialOM() {
    let materialOM = 0;
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        if (this.buildings[i].materialEstimates[j].cost === 'O&M') {
          materialOM += Number(this.buildings[i].materialEstimates[j].totalCosts);
        }
      }
    }
    return Math.round(materialOM);
  }

  contingencyOM() {
    let contingencyOM = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (this.contingencyDetails[i].cost === 'Contingency-O&M') {
        contingencyOM += Number(this.contingencyDetails[i].totalCosts || 0);
      }
    }
    return Math.round(contingencyOM);
  }

  otherOM() {
    let otherOM = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (this.contingencyDetails[i].cost === 'Other-O&M') {
        otherOM += Number(this.contingencyDetails[i].totalCosts || 0);
      }
    }
    return Math.round(otherOM);
  }

  subtotalOM() {
    return (
      this.internalOM() +
      this.externalOM() +
      this.materialOM() +
      this.contingencyOM() +
      this.otherOM()
    );
  }

  subtotalOMThisRequest() {
    return this.subtotalOM() - this.previousOMSubtotal;
  }

  internalCapital(isAFUDC?: boolean) {
    let internalCapital = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask.workTask === 'Hardware-CAP' ||
        (this.laborDetails[i].workTask.workTask === 'Hardware-Removal' && !isAFUDC) ||
        this.laborDetails[i].workTask.workTask === 'Software-CAP'
      ) {
        if (this.laborDetails[i].chargeType === 'Internal') {
          internalCapital += Number(this.laborDetails[i].totalCosts || 0);
        }
      }
    }
    return Math.round(internalCapital);
  }

  externalCapital(isAFUDC?: boolean) {
    let externalCapital = 0;
    for (let i = 0; i < this.laborDetails.length; i++) {
      if (
        this.laborDetails[i].workTask.workTask === 'Hardware-CAP' ||
        (this.laborDetails[i].workTask.workTask === 'Hardware-Removal' && !isAFUDC) ||
        this.laborDetails[i].workTask.workTask === 'Software-CAP'
      ) {
        if (this.laborDetails[i].chargeType === 'External') {
          externalCapital += Number(this.laborDetails[i].totalCosts || 0);
        }
      }
    }
    return Math.round(externalCapital);
  }

  materialCapital() {
    let materialCapital = 0;
    for (let i = 0; i < this.buildings.length; i++) {
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        if (this.buildings[i].materialEstimates[j].cost === 'CAP') {
          materialCapital += Number(this.buildings[i].materialEstimates[j].totalCosts);
        }
      }
    }
    return Math.round(materialCapital);
  }

  contingencyCapital(isAFUDC?: boolean) {
    let contingencyCapital = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (
        this.contingencyDetails[i].cost === 'Contingency-CAP' ||
        (this.contingencyDetails[i].cost === 'Contingency-Removal' && !isAFUDC)
      ) {
        contingencyCapital += Number(this.contingencyDetails[i].totalCosts || 0);
      }
    }
    return Math.round(contingencyCapital);
  }

  otherCapital(isAFUDC?: boolean) {
    let otherCapital = 0;
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      if (
        this.contingencyDetails[i].cost === 'Other-CAP' ||
        (this.contingencyDetails[i].cost === 'Other-Removal' && !isAFUDC)
      ) {
        otherCapital += Number(this.contingencyDetails[i].totalCosts || 0);
      }
    }
    return Math.round(otherCapital);
  }

  subtotalCapital(isAFUDC?: boolean) {
    return (
      this.internalCapital(isAFUDC) +
      this.externalCapital(isAFUDC) +
      this.materialCapital() +
      this.contingencyCapital(isAFUDC) +
      this.otherCapital(isAFUDC)
    );
  }

  subtotalCapitalThisRequest() {
    return this.subtotalCapital() - this.previousCapitalSubtotal;
  }

  estimatedAFUDC() {
    let percentageTotal = 0;
    for (let i = 0; i < this.allocations.length; i++) {
      if (
        this.allocations[i].businessUnitValue &&
        !this.allocations[i].businessUnitValue.startsWith('502')
      ) {
        percentageTotal += this.allocations[i].percentage;
      }
    }
    percentageTotal = percentageTotal / 100;
    let diffInDays = Math.floor(
      (+this.estimatedInServiceDate - +this.estimatedStartDate) / (1000 * 60 * 60 * 24)
    );
    return Math.round(
      (diffInDays / 360) * 0.065 * ((this.subtotalCapital(true) * percentageTotal) / 2)
    );
  }

  totalCapitalCost() {
    return this.subtotalCapital() + this.estimatedAFUDC();
  }

  totalProjectCost() {
    return this.totalCapitalCost() + this.subtotalOM();
  }

  base64ImageToBlob(str) {
    // extract content type and base64 payload from original string
    let pos = str.indexOf(';base64,');
    let type = str.substring(5, pos);
    let b64 = str.substr(pos + 8);

    // decode base64
    let imageContent = atob(b64);

    // create an ArrayBuffer and a view (as unsigned 8-bit)
    let buffer = new ArrayBuffer(imageContent.length);
    let view = new Uint8Array(buffer);

    // fill the view, using the decoded base64
    for (let n = 0; n < imageContent.length; n++) {
      view[n] = imageContent.charCodeAt(n);
    }

    // convert ArrayBuffer to Blob
    let blob = new Blob([buffer], { type: type });

    return blob;
  }

  submitForm() {
    if (!this.formNumber) {
      this.generateFormNumber();
    } else {
      this.saveItSparData(true, this.selectSPARReviewer());
    }
  }

  generateGUID(isDraftSave?: boolean, isSubmission?: boolean) {
    this.dataService.getSparGuid().subscribe(
      (result: any) => {
        this.itSparGuid = result.body.itspar_guid;
        sessionStorage.setItem('itSparGuid', JSON.stringify(this.itSparGuid));
        if (isDraftSave) {
          this.saveItSparData();
        }
        if (isSubmission) {
          this.saveItSparData(true, this.selectSPARReviewer());
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Generate IT SPAR GUID Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Generate IT SPAR GUID Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  generateFormNumber() {
    const allocations = this.allocations;
    const operatingUnits = this.allocations.map((allocation) => {
      const opUnitKey = (allocation.operatingUnit && allocation.operatingUnit.OPERATING_UNIT) || '';
      const unitDetails = this.nuclearAbbreviations.find(
        (abbrev) => abbrev.operatingUnit === opUnitKey
      );
      return {
        operatingUnit: opUnitKey,
        businessUnit: (allocation.operatingUnit && allocation.operatingUnit.BUSINESS_UNIT) || '',
        stationCode: (unitDetails && unitDetails.stationCode) || '',
      };
    });
    let callBody = {
      patiPrjInput: '',
      operatingUnits,
      isMultipleNuclear: false,
    };
    if (this.hardwareOrSoftware === 'Hardware and Software' || this.containsMultipleNuclear()) {
      callBody.patiPrjInput = '[["'.concat(this.patiProject.Project_ID).concat('",2]]');
      if (this.containsMultipleNuclear()) {
        callBody.isMultipleNuclear = true;
      }
    } else {
      callBody.patiPrjInput = '[["'.concat(this.patiProject.Project_ID).concat('",3]]');
    }
    this.dataService.getProjectID(callBody).subscribe(
      (result: any) => {
        if (result.body[0][1].includes('D_Max_Reached')) {
          let errorType = 'Form Number Limit Exceeded';
          let errorDescription =
            'The limit has been reached for form numbers for this PaTi ID.  Please save your form as draft and contact PAC.';
          let dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription,
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true,
          });
        } else {
          this.formNumber = result.body[0][0].concat(result.body[0][1]);
          if (this.itSparGuid) {
            this.saveItSparData(true, this.selectSPARReviewer());
          } else {
            this.generateGUID(false, true);
          }
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Project IDs Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Project IDs Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  containsMultipleNuclear() {
    let nuclearFound = 0;
    for (let i = 0; i < this.allocations.length && nuclearFound < 2; i++) {
      if (
        this.allocations[i].businessUnitValue === '20048' ||
        this.allocations[i].businessUnitValue === '50125'
      ) {
        let matchFound = false;
        for (let j = 0; j < this.nuclearAbbreviations.length && !matchFound; j++) {
          if (
            this.allocations[i].operatingUnit.OPERATING_UNIT ===
            this.nuclearAbbreviations[j].operatingUnit
          ) {
            matchFound = true;
            nuclearFound++;
          }
        }
      }
    }
    return nuclearFound === 2;
  }

  loadUOPOptionsFile() {
    this.http.get('assets/uop-options.json').subscribe(
      (result) => {
        this.uopOptions = result as string[];
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load UOP Options Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load UOP Options Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  goToApprovalPage() {
    this.router.navigate(['/it-project-approval']);
  }

  saveItSparData(isSubmission?: boolean, sparReviewer?: GraphUser) {
    let releaseDetailsObject = [];
    for (let i = 0; i < this.releaseDetails.length; i++) {
      releaseDetailsObject.push({
        capabilityDetails: [],
      });
      for (let j = 0; j < this.releaseDetails[i].capabilityDetails.length; j++) {
        releaseDetailsObject[i].capabilityDetails.push({
          releaseNumber: this.releaseDetails[i].capabilityDetails[j].releaseNumber,
          releaseDate: this.releaseDetails[i].capabilityDetails[j].releaseDate,
          capability: this.releaseDetails[i].capabilityDetails[j].capabilities,
          description: this.releaseDetails[i].capabilityDetails[j].description,
          capitalCost: this.releaseDetails[i].capabilityDetails[j].capitalCost,
          omCost: this.releaseDetails[i].capabilityDetails[j].omCost,
        });
      }
    }
    let allocationsObject = [];
    for (let i = 0; i < this.allocations.length; i++) {
      allocationsObject.push({
        operatingUnit: JSON.stringify(this.allocations[i].operatingUnit),
        businessUnit: this.allocations[i].businessUnit,
        fundingProjectId: JSON.stringify(this.allocations[i].fundingProjectID),
        function: this.allocations[i].function,
        state: this.allocations[i].state,
        percentage: `${this.allocations[i].percentage}`,
      });
    }
    let buildingsObject = [];
    for (let i = 0; i < this.buildings.length; i++) {
      buildingsObject.push({
        building: JSON.stringify(this.buildings[i].buildingName),
        materialEstimates: [],
      });
      for (let j = 0; j < this.buildings[i].materialEstimates.length; j++) {
        buildingsObject[i].materialEstimates.push({
          cost: this.buildings[i].materialEstimates[j].cost,
          details: this.buildings[i].materialEstimates[j].unitOfPropertyDetails,
          uopDescription: this.buildings[i].materialEstimates[j].unitOfPropertyDescription,
          quantity: this.buildings[i].materialEstimates[j].quantity,
          unitCosts: this.buildings[i].materialEstimates[j].unitCosts,
          totalCosts: this.buildings[i].materialEstimates[j].totalCosts,
        });
      }
    }
    let laborDetailsObject = [];
    for (let i = 0; i < this.laborDetails.length; i++) {
      laborDetailsObject.push({
        workTask: JSON.stringify(this.laborDetails[i].workTask),
        workDescription: this.laborDetails[i].workDescription,
        chargeType: this.laborDetails[i].chargeType,
        totalCosts: this.laborDetails[i].totalCosts,
      });
    }
    let contingencyDetailsObject = [];
    for (let i = 0; i < this.contingencyDetails.length; i++) {
      contingencyDetailsObject.push({
        cost: this.contingencyDetails[i].cost,
        description: this.contingencyDetails[i].description,
        totalCosts: this.contingencyDetails[i].totalCosts,
      });
    }
    let filesObject = [];
    for (let i = 0; i < this.files.length; i++) {
      filesObject.push(JSON.stringify(this.files[i]));
    }
    let additionalApproverObject = [];
    for (let i = 0; i < this.additionalApprovers.length; i++) {
      additionalApproverObject.push({
        displayName: this.additionalApprovers[i].displayName,
        givenName: this.additionalApprovers[i].givenName,
        surname: this.additionalApprovers[i].surname,
        mail: this.additionalApprovers[i].mail,
        mailNickname: this.additionalApprovers[i].mailNickname,
        jobTitle: this.additionalApprovers[i].jobTitle,
        doaAmount: this.doaAmounts[i + 1],
      });
    }
    additionalApproverObject = _.orderBy(additionalApproverObject, [
      'doaAmount',
      'surname',
      'givenName',
      'displayName',
    ]);
    let formStatusValue = '';
    if (isSubmission) {
      formStatusValue = 'ET&S PAC Review';
    } else {
      formStatusValue = 'Draft';
    }
    let formActivityValue = [];
    let etsPacAssignmentValue = null;
    if (isSubmission) {
      let savedDate = new Date();
      let options = { month: 'long', day: 'numeric', year: 'numeric' };
      let formattedDate = savedDate.toLocaleDateString('en-US', options as any);
      let savedTime = this.formatAMPM(savedDate);
      formActivityValue.unshift({
        name: this.userName,
        email: this.userEmail,
        comment: '',
        action: 'Submitted',
        day: formattedDate,
        time: savedTime,
      });
      etsPacAssignmentValue = {
        displayName: sparReviewer.displayName,
        givenName: sparReviewer.givenName,
        surname: sparReviewer.surname,
        mail: sparReviewer.mail,
        mailNickname: sparReviewer.mailNickname,
        jobTitle: sparReviewer.jobTitle,
        doaAmount: '',
      };
    } else {
      etsPacAssignmentValue = {
        displayName: '',
        givenName: '',
        surname: '',
        mail: '',
        mailNickname: '',
        jobTitle: '',
        doaAmount: '',
      };
    }
    let formOwnerValue = {};
    formOwnerValue = {
      displayName: '',
      givenName: this.firstName,
      surname: this.lastName,
      mail: this.userEmail,
      mailNickname: '',
      jobTitle: '',
      doaAmount: '',
    };
    let callBody = {
      itSparGuid: this.itSparGuid,
      patiId: JSON.stringify(this.patiProject),
      shortDescription: this.projectName,
      etsProjectClassification: JSON.stringify(this.itProjectClassification),
      estimatedStartDate: this.convertToDateStringFormat(this.estimatedStartDate),
      estimatedInServiceDate: this.convertToDateStringFormat(this.estimatedInServiceDate),
      overviewAndScope: this.projectScopeDescription,
      primaryContact: {
        displayName: this.primaryContact ? this.primaryContact.displayName : null,
        givenName: this.primaryContact ? this.primaryContact.givenName : null,
        surname: this.primaryContact ? this.primaryContact.surname : null,
        mail: this.primaryContact ? this.primaryContact.mail : null,
        mailNickname: this.primaryContact ? this.primaryContact.mailNickname : null,
        jobTitle: this.primaryContact ? this.primaryContact.jobTitle : null,
      },
      itSponsor: {
        displayName: this.itSponsor ? this.itSponsor.displayName : null,
        givenName: this.itSponsor ? this.itSponsor.givenName : null,
        surname: this.itSponsor ? this.itSponsor.surname : null,
        mail: this.itSponsor ? this.itSponsor.mail : null,
        mailNickname: this.itSponsor ? this.itSponsor.mailNickname : null,
        jobTitle: this.itSponsor ? this.itSponsor.jobTitle : null,
        doaAmount: this.doaAmounts && this.doaAmounts.length > 0 ? this.doaAmounts[0] : null,
      },
      omOnly: this.omOnly,
      relatedWork: this.relatedWork,
      hardwareOrSoftware: this.hardwareOrSoftware,
      purchasingWarranties: this.purchasingWarranties,
      projectConsistsOf: this.projectConsistsOf,
      expectedLife: this.expectedLife,
      agileEffort: this.agileEffort,
      softwareBeingUsed: this.softwareBeingUsed,
      vendorName: this.vendorName,
      softwareName: this.softwareName,
      inServiceYear: this.inServiceYear,
      softwareProjectOverview: this.softwareProjectOverview,
      dataConversionActivities: this.dataConversionActivities,
      trainingCosts: this.trainingCosts,
      associatedRetirement: this.associatedRetirement,
      softwareToBeRetired: this.softwareToBeRetired,
      retiredInServiceDate: this.retiredInServiceDate,
      maintenanceContracts: this.maintenanceContracts,
      replacingInterfaces: this.replacingInterfaces,
      howSoftwareReleased: this.howSoftwareReleased,
      perpetualLicenses: this.perpetualLicenses,
      contractualRight: this.contractualRight,
      significantPenalty: this.significantPenalty,
      isFeasible: this.isFeasible,
      serviceFees: this.serviceFees,
      useWithoutPaying: this.useWithoutPaying,
      department: JSON.stringify(this.department),
      buildingInfo: JSON.stringify(this.buildingInfo),
      releaseDetails: releaseDetailsObject,
      distributeCost: JSON.stringify(this.distributeCost),
      defaultOption: JSON.stringify(this.defaultOption),
      allocations: allocationsObject,
      buildings: buildingsObject,
      laborDetails: laborDetailsObject,
      contingencyDetails: contingencyDetailsObject,
      additionalComments: this.additionalComments,
      attachments: filesObject,
      approvers: additionalApproverObject,
      formStatus: formStatusValue,
      formActivity: formActivityValue,
      currentApprover: {
        displayName: '',
        givenName: '',
        surname: '',
        mail: '',
        mailNickname: '',
        jobTitle: '',
        doaAmount: '',
      },
      formOwner: formOwnerValue,
      etsPacAssignment: etsPacAssignmentValue,
      currentAssignment: etsPacAssignmentValue,
      tables: '',
      effectiveDate: '',
      formNumber: this.formNumber,
      displayRevisionNumber: this.displayRevisionNumber,
      previousCapitalSubtotal: this.previousCapitalSubtotal.toString(),
      previousOMSubtotal: this.previousOMSubtotal.toString(),
      revisionExists: 'false',
    };
    this.dataService.saveItSparData(callBody).subscribe(
      (result) => {
        if (result.statusCode !== 200) {
          console.log('error', result);
          let errorType = '';
          let errorDescription = result;
          let dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription,
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true,
          });
        } else {
          if (!isSubmission) {
            this.draftSaved = 'Saved';
            this.draftSavedDate = new Date();
            this.draftSavedDay =
              (this.draftSavedDate.getMonth() > 8
                ? this.draftSavedDate.getMonth() + 1
                : '0' + (this.draftSavedDate.getMonth() + 1)) +
              '/' +
              (this.draftSavedDate.getDate() > 9
                ? this.draftSavedDate.getDate()
                : '0' + this.draftSavedDate.getDate()) +
              '/' +
              this.draftSavedDate.getFullYear();
            this.draftSavedTime = this.formatAMPM(this.draftSavedDate);
            sessionStorage.setItem('draftSaved', this.draftSaved);
            sessionStorage.setItem('draftSavedDay', this.draftSavedDay);
            sessionStorage.setItem('draftSavedTime', this.draftSavedTime);
          } else {
            // send email to selected IT PAC reviewer
            let dataStructure = {
              sendingReviewEmail: true,
              sendingReviewReceiver: [etsPacAssignmentValue.mail],
              sendingReviewFirstName: [etsPacAssignmentValue.givenName],
            };
            this.sendEmailNotifications(dataStructure);
            this.goToApprovalPage();
          }
        }
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Save IT SPAR Data Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Save IT SPAR Data Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  convertToDateStringFormat(date: Date): string {
    return (
      date.getFullYear().toString() +
      '-' +
      (date.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      date.getDate().toString().padStart(2, '0')
    );
  }

  saveDraft() {
    if (this.itSparGuid) {
      this.saveItSparData();
    } else {
      this.generateGUID(true);
    }
  }

  formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;
  }

  sendEmailNotifications(dataStructure: any) {
    if (dataStructure.sendingReviewEmail) {
      let emailBody = '';
      let emailSubject = '';
      for (let i = 0; i < dataStructure.sendingReviewReceiver.length; i++) {
        emailBody =
          '<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">';
        emailBody = emailBody.concat(dataStructure.sendingReviewFirstName[i]);
        emailBody = emailBody.concat(
          ',</span></div><div><span style="font-size: 0.875rem">The <a href="'
        );
        emailBody = emailBody.concat(this.config.getConfig('RedirectUri'));
        emailBody = emailBody.concat('/it-project-approval?guid=');
        emailBody = emailBody.concat(this.itSparGuid);
        emailBody = emailBody.concat('&revisionNum=');
        emailBody = emailBody.concat(this.displayRevisionNumber.toString());
        emailBody = emailBody.concat(
          '" style="font-size: 0.875rem">ET&S Accounting Request Form #'
        );
        emailBody = emailBody.concat(this.formNumber);
        if (this.displayRevisionNumber > 0) {
          emailBody = emailBody.concat(', Rev ');
          emailBody = emailBody.concat(this.displayRevisionNumber.toString());
        }
        emailBody = emailBody.concat(' ');
        emailBody = emailBody.concat(this.projectName);
        emailBody = emailBody.concat(
          '</a> is available for your review.</span></div></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">Please click below to review and approve or reject the form.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="'
        );
        emailBody = emailBody.concat(this.config.getConfig('RedirectUri'));
        emailBody = emailBody.concat('/it-project-approval?guid=');
        emailBody = emailBody.concat(this.itSparGuid);
        emailBody = emailBody.concat('&revisionNum=');
        emailBody = emailBody.concat(this.displayRevisionNumber.toString());
        emailBody = emailBody.concat(
          '"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">REVIEW THE FORM</span></div></a></div>'
        );
        let environment = this.config.getConfig('EnvName');
        if (environment !== 'prod') {
          emailSubject = 'TEST ('.concat(environment).concat(') - ');
        } else {
          emailSubject = '';
        }
        if (this.displayRevisionNumber > 0) {
          emailSubject = emailSubject.concat(
            'Ready for Review - ET&S ARF Form #'
              .concat(this.formNumber)
              .concat(', Rev ')
              .concat(this.displayRevisionNumber.toString())
              .concat(' (MMAPS)')
          );
        } else if (this.displayRevisionNumber === 0) {
          emailSubject = emailSubject.concat(
            'Ready for Review - ET&S ARF Form #'.concat(this.formNumber).concat(' (MMAPS)')
          );
        }
        if (dataStructure.sendingReviewReceiver[i]) {
          let callBody = {
            email: dataStructure.sendingReviewReceiver[i],
            sub: emailSubject,
            body: emailBody,
            role: 'ET&S PAC Reviewer',
          };
          this.dataService.sendEmail(callBody).subscribe(
            (result) => {
              if (result.statusCode !== 200) {
                console.log('error', result);
                let errorType = '';
                let errorDescription = JSON.parse(result.body).message;
                let dataStructure = {
                  errorType: errorType,
                  errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                  data: dataStructure,
                  disableClose: true,
                });
              }
            },
            (error) => {
              console.log('error', error);
              let errorType = '';
              let errorDescription = '';
              if (error.error.message) {
                errorDescription = errorDescription.concat(
                  'Send Email Error - ',
                  error.error.message
                );
              } else {
                errorDescription = errorDescription.concat('Send Email Error');
              }
              errorType = errorType.concat(error.status, ' ', error.statusText);
              let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
              };
              this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
              });
            }
          );
        }
      }
    }
    if (dataStructure.sendingModifiedEmail) {
      let emailBody = '';
      let emailSubject = '';
      for (let i = 0; i < dataStructure.sendingModifiedReceiver.length; i++) {
        emailBody =
          '<div style="margin: auto; text-align: center; width: 42.75rem"><div style="text-align: left"><span style="font-size: 0.875rem">';
        emailBody = emailBody.concat(dataStructure.sendingModifiedFirstName[i]);
        emailBody = emailBody.concat(
          ',</span></div><div><span style="font-size: 0.875rem">Action has been taken on your <a href="'
        );
        emailBody = emailBody.concat(this.config.getConfig('RedirectUri'));
        emailBody = emailBody.concat('/it-project-approval?guid=');
        emailBody = emailBody.concat(this.itSparGuid);
        emailBody = emailBody.concat('&revisionNum=');
        emailBody = emailBody.concat(this.displayRevisionNumber.toString());
        emailBody = emailBody.concat(
          '" style="font-size: 0.875rem">ET&S Accounting Request Form #'
        );
        emailBody = emailBody.concat(this.formNumber);
        if (this.displayRevisionNumber > 0) {
          emailBody = emailBody.concat(', Rev ');
          emailBody = emailBody.concat(this.displayRevisionNumber.toString());
        }
        emailBody = emailBody.concat(' ');
        emailBody = emailBody.concat(this.projectName);
        emailBody = emailBody.concat('</a> by ');
        emailBody = emailBody.concat(dataStructure.sendingModifiedName);
        emailBody = emailBody.concat(
          '.</span></div></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><span style="font-size: 0.875rem">Please click below to view the updated form.</span></div><div style="margin: auto; text-align: center; margin-top: 1.5rem;"><a href="'
        );
        emailBody = emailBody.concat(this.config.getConfig('RedirectUri'));
        emailBody = emailBody.concat('/it-project-approval?guid=');
        emailBody = emailBody.concat(this.itSparGuid);
        emailBody = emailBody.concat('&revisionNum=');
        emailBody = emailBody.concat(this.displayRevisionNumber.toString());
        emailBody = emailBody.concat(
          '"><div style="width: 14.25rem; background: rgb(0, 120, 158); border-radius: 0.125rem; height: 2.75rem; display: inline-block; cursor: pointer; border-width: 0;"><span style="color: rgb(255, 255, 255); font-size: 0.875rem; font-weight: normal; letter-spacing: 0.01rem; line-height: 1.063rem;">VIEW THE FORM</span></div></a></div>'
        );
        let environment = this.config.getConfig('EnvName');
        if (environment !== 'prod') {
          emailSubject = 'TEST ('.concat(environment).concat(') - ');
        } else {
          emailSubject = '';
        }
        if (this.displayRevisionNumber > 0) {
          emailSubject = emailSubject.concat(
            'Action Taken - ET&S ARF Form #'
              .concat(this.formNumber)
              .concat(', Rev ')
              .concat(this.displayRevisionNumber.toString())
              .concat(' (MMAPS)')
          );
        } else if (this.displayRevisionNumber === 0) {
          emailSubject = emailSubject.concat(
            'Action Taken - ET&S ARF Form #'.concat(this.formNumber).concat(' (MMAPS)')
          );
        }
        if (dataStructure.sendingModifiedReceiver[i]) {
          const modifiedRole =
            dataStructure.sendingModifiedReceiver[i] ===
            (this.primaryContact && this.primaryContact.mail)
              ? 'Primary Contact'
              : dataStructure.sendingModifiedReceiver[i] ===
                  (this.etsPacAssignment && this.etsPacAssignment.mail)
                ? 'IT PAC Assignment'
                : undefined;
          let callBody = {
            email: dataStructure.sendingModifiedReceiver[i],
            sub: emailSubject,
            body: emailBody,
            ...(modifiedRole && { role: modifiedRole }),
          };
          this.dataService.sendEmail(callBody).subscribe(
            (result) => {
              if (result.statusCode !== 200) {
                console.log('error', result);
                let errorType = '';
                let errorDescription = JSON.parse(result.body).message;
                let dataStructure = {
                  errorType: errorType,
                  errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                  data: dataStructure,
                  disableClose: true,
                });
              }
            },
            (error) => {
              console.log('error', error);
              let errorType = '';
              let errorDescription = '';
              if (error.error.message) {
                errorDescription = errorDescription.concat(
                  'Send Email Error - ',
                  error.error.message
                );
              } else {
                errorDescription = errorDescription.concat('Send Email Error');
              }
              errorType = errorType.concat(error.status, ' ', error.statusText);
              let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
              };
              this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
              });
            }
          );
        }
      }
    }
  }

  loadPACEmailFile() {
    this.http.get('assets/pac-email.json').subscribe(
      (result) => {
        this.pacEmail = result as any;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Catawba Operating Units Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Catawba Operating Units Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  loadEmailRecipientsFile() {
    this.http.get('assets/email_recipients.json').subscribe(
      (result) => {
        this.emailRecipients = result as any;
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Load Email Recipients Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Load Email Recipients Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getPACUsers() {
    let pacGroup = this.config.getConfig('ItPacGroup');
    this.dataService.getGroupId(pacGroup).subscribe(
      (result) => {
        this.dataService.getPACUserList((result as any).value[0].id).subscribe(
          (result) => {
            this.pacUsers = (result as any).value;
          },
          (error) => {
            console.log('error', error);
            let errorType = '';
            let errorDescription = '';
            if (error.error.message) {
              errorDescription = errorDescription.concat(
                'Get PAC User List Error - ',
                error.error.message
              );
            } else {
              errorDescription = errorDescription.concat('Get PAC User List Error');
            }
            errorType = errorType.concat(error.status, ' ', error.statusText);
            let dataStructure = {
              errorType: errorType,
              errorDescription: errorDescription,
            };
            this.dialog.open(ErrorDialogComponent, {
              data: dataStructure,
              disableClose: true,
            });
          }
        );
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get PAC Group ID Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get PAC Group ID Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  getPACOrder() {
    let data = {
      fileName: 'pac-order.json',
      contentType: 'application/json',
      method: 'get_object',
    };
    this.dataService.getPresignedURL(data).subscribe(
      (result) => {
        let presignedUrl = JSON.parse(result as string).presigned_url;
        this.http
          .get(presignedUrl, {
            responseType: 'blob',
          })
          .subscribe(
            (result) => {
              (result as any).text().then((text) => {
                this.pacOrder = JSON.parse(text);
              });
            },
            (error) => {
              if (error.status === 404) {
                this.pacOrder = [];
                this.savePACOrder('[]');
              } else {
                console.log('error', error);
                let errorType = '';
                let errorDescription = '';
                if (error.error.message) {
                  errorDescription = errorDescription.concat(
                    'Get PAC Order File Error - ',
                    error.error.message
                  );
                } else {
                  errorDescription = errorDescription.concat('Get PAC Order File Error');
                }
                errorType = errorType.concat(error.status, ' ', error.statusText);
                let dataStructure = {
                  errorType: errorType,
                  errorDescription: errorDescription,
                };
                this.dialog.open(ErrorDialogComponent, {
                  data: dataStructure,
                  disableClose: true,
                });
              }
            }
          );
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Presigned URL Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Presigned URL Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  savePACOrder(fileBody: string) {
    let data = {
      fileName: 'pac-order.json',
      contentType: 'application/json',
      method: 'put_object',
    };
    this.dataService.getPresignedURL(data).subscribe(
      (result) => {
        let presignedURL = JSON.parse(result as string).presigned_url;
        const blob = new Blob([fileBody], { type: 'application/json' });
        const file = new File([blob], 'pac-order.json', {
          type: 'application/json',
        });
        this.httpNoInterceptors
          .put(presignedURL, file, { headers: { 'Content-Type': file.type } })
          .subscribe(
            (result) => {},
            (error) => {
              console.log('error', error);
              let errorType = '';
              let errorDescription = '';
              if (error.error.message) {
                errorDescription = errorDescription.concat(
                  'Upload PAC Order to Presigned URL Error - ',
                  error.error.message
                );
              } else {
                errorDescription = errorDescription.concat(
                  'Upload PAC Order to Presigned URL Error'
                );
              }
              errorType = errorType.concat(error.status, ' ', error.statusText);
              let dataStructure = {
                errorType: errorType,
                errorDescription: errorDescription,
              };
              this.dialog.open(ErrorDialogComponent, {
                data: dataStructure,
                disableClose: true,
              });
            }
          );
      },
      (error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat(
            'Get Presigned URL Error - ',
            error.error.message
          );
        } else {
          errorDescription = errorDescription.concat('Get Presigned URL Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText);
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription,
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true,
        });
      }
    );
  }

  selectSPARReviewer() {
    if (this.etsPacAssignment) {
      return this.etsPacAssignment;
    }
    let foundIndexes = [];
    for (let i = 0; i < this.pacUsers.length; i++) {
      let matchFound = false;
      for (let j = 0; j < this.pacOrder.length && !matchFound; j++) {
        if (
          this.pacUsers[i].mail &&
          this.pacOrder[j].mail &&
          this.pacUsers[i].mail.toLowerCase() === this.pacOrder[j].mail.toLowerCase()
        ) {
          matchFound = true;
          foundIndexes.push(j);
        }
      }
      if (!matchFound) {
        this.pacOrder.unshift({
          displayName: this.pacUsers[i].displayName,
          givenName: this.pacUsers[i].givenName,
          surname: this.pacUsers[i].surname,
          mail: this.pacUsers[i].mail,
          mailNickname: this.pacUsers[i].mailNickname,
          jobTitle: this.pacUsers[i].jobTitle,
        });
        this.savePACOrder(JSON.stringify(this.pacOrder));
        return {
          displayName: this.pacUsers[i].displayName,
          givenName: this.pacUsers[i].givenName,
          surname: this.pacUsers[i].surname,
          mail: this.pacUsers[i].mail,
          mailNickname: this.pacUsers[i].mailNickname,
          jobTitle: this.pacUsers[i].jobTitle,
        };
      }
    }
    let lowestFoundIndex = -1;
    let lowestFoundValue = -1;
    for (let i = 0; i < foundIndexes.length; i++) {
      if (foundIndexes[i] > lowestFoundValue) {
        lowestFoundValue = foundIndexes[i];
        lowestFoundIndex = i;
      }
    }
    this.pacOrder.splice(lowestFoundValue, 1);
    this.pacOrder.unshift({
      displayName: this.pacUsers[lowestFoundIndex].displayName,
      givenName: this.pacUsers[lowestFoundIndex].givenName,
      surname: this.pacUsers[lowestFoundIndex].surname,
      mail: this.pacUsers[lowestFoundIndex].mail,
      mailNickname: this.pacUsers[lowestFoundIndex].mailNickname,
      jobTitle: this.pacUsers[lowestFoundIndex].jobTitle,
    });
    this.savePACOrder(JSON.stringify(this.pacOrder));
    return {
      displayName: this.pacUsers[lowestFoundIndex].displayName,
      givenName: this.pacUsers[lowestFoundIndex].givenName,
      surname: this.pacUsers[lowestFoundIndex].surname,
      mail: this.pacUsers[lowestFoundIndex].mail,
      mailNickname: this.pacUsers[lowestFoundIndex].mailNickname,
      jobTitle: this.pacUsers[lowestFoundIndex].jobTitle,
    };
  }

  openCapabilityDialog(i: number, j: number) {
    this.dialog.open(CapabilityDescriptionComponent, {
      data: {
        capabilityDetails: this.releaseDetails[i].capabilityDetails[j],
        readOnly: true,
      },
      disableClose: true,
    });
  }

  showFunctionField(allocation: Allocation) {
    return ['PWGCT', 'EDIST'].includes(allocation.setId);
  }

  isAllocationFunctionVisible(allocations: Allocation[]) {
    return allocations.some((a) => this.showFunctionField(a));
  }
}
